
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as anunciar_45imovelfeUgrqGtjLMeta } from "/app/app/pages/anunciar-imovel.vue?macro=true";
import { default as authDQ69vf3dFpMeta } from "/app/app/pages/auth.vue?macro=true";
import { default as _91slug_931tzGgUiqM9Meta } from "/app/app/pages/bairros/[slug].vue?macro=true";
import { default as casas_45em_45condominioSvhDdkQJDgMeta } from "/app/app/pages/casas-em-condominio.vue?macro=true";
import { default as _91slug_93hKIlhuz7xQMeta } from "/app/app/pages/colecao/[slug].vue?macro=true";
import { default as _91condoSlug_93aQhrXw6IgRMeta } from "/app/app/pages/condominio/[condoSlug].vue?macro=true";
import { default as _91_91unavailableCommercialId_93_93rw8TghPLEXMeta } from "/app/app/pages/imovel-indisponivel/[[unavailableCommercialId]].vue?macro=true";
import { default as _91_91slug_93_93OLDu5eIYKuMeta } from "/app/app/pages/imovel/[commercialId]/[[slug]].vue?macro=true";
import { default as indexM6mJRhIbwTMeta } from "/app/app/pages/index.vue?macro=true";
import { default as mapa_45do_45siteyuiFLUOso0Meta } from "/app/app/pages/mapa-do-site.vue?macro=true";
import { default as off_45marketujwyYFMp5PMeta } from "/app/app/pages/off-market.vue?macro=true";
import { default as perfilBgahg6Da73Meta } from "/app/app/pages/perfil.vue?macro=true";
import { default as politica_45de_45cookies0j1lAjfhyWMeta } from "/app/app/pages/politica-de-cookies.vue?macro=true";
import { default as politica_45de_45privacidadet0ZCY8jWu0Meta } from "/app/app/pages/politica-de-privacidade.vue?macro=true";
import { default as sobre_45a_45pilarIJNr3UkQoYMeta } from "/app/app/pages/sobre-a-pilar.vue?macro=true";
import { default as termos_45de_45usoxd5JMe7ZojMeta } from "/app/app/pages/termos-de-uso.vue?macro=true";
import { default as politica_45de_45privacidadepQi9ucIS88Meta } from "/app/app/pages/termos/politica-de-privacidade.vue?macro=true";
import { default as termo_45de_45responsabilidade_45dados_45pessoais1JAH84Ff3QMeta } from "/app/app/pages/termos/termo-de-responsabilidade-dados-pessoais.vue?macro=true";
import { default as termo_45de_45uso_45b2c4Ww2GXfkMiMeta } from "/app/app/pages/termos/termo-de-uso-b2c.vue?macro=true";
import { default as _91_46_46_46filterSlugs_93xl0zcCbgIlMeta } from "/app/app/pages/venda/imoveis/[...filterSlugs].vue?macro=true";
import { default as _91_46_46_46filterSlugs_93vX2UX9obqKMeta } from "/app/app/pages/venda/mapa-de-imoveis/[...filterSlugs].vue?macro=true";
export default [
  {
    name: "anunciar-imovel",
    path: "/anunciar-imovel",
    meta: anunciar_45imovelfeUgrqGtjLMeta || {},
    component: () => import("/app/app/pages/anunciar-imovel.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: authDQ69vf3dFpMeta || {},
    component: () => import("/app/app/pages/auth.vue")
  },
  {
    name: "bairros-slug",
    path: "/bairros/:slug()",
    meta: _91slug_931tzGgUiqM9Meta || {},
    component: () => import("/app/app/pages/bairros/[slug].vue")
  },
  {
    name: "casas-em-condominio",
    path: "/casas-em-condominio",
    component: () => import("/app/app/pages/casas-em-condominio.vue")
  },
  {
    name: "colecao-slug",
    path: "/colecao/:slug()",
    meta: _91slug_93hKIlhuz7xQMeta || {},
    component: () => import("/app/app/pages/colecao/[slug].vue")
  },
  {
    name: "condominio-condoSlug",
    path: "/condominio/:condoSlug()",
    meta: _91condoSlug_93aQhrXw6IgRMeta || {},
    component: () => import("/app/app/pages/condominio/[condoSlug].vue")
  },
  {
    name: "imovel-indisponivel-unavailableCommercialId",
    path: "/imovel-indisponivel/:unavailableCommercialId?",
    component: () => import("/app/app/pages/imovel-indisponivel/[[unavailableCommercialId]].vue")
  },
  {
    name: "imovel-commercialId-slug",
    path: "/imovel/:commercialId()/:slug?",
    meta: _91_91slug_93_93OLDu5eIYKuMeta || {},
    component: () => import("/app/app/pages/imovel/[commercialId]/[[slug]].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexM6mJRhIbwTMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "mapa-do-site",
    path: "/mapa-do-site",
    component: () => import("/app/app/pages/mapa-do-site.vue")
  },
  {
    name: "off-market",
    path: "/off-market",
    meta: off_45marketujwyYFMp5PMeta || {},
    component: () => import("/app/app/pages/off-market.vue")
  },
  {
    name: "perfil",
    path: "/perfil",
    meta: perfilBgahg6Da73Meta || {},
    component: () => import("/app/app/pages/perfil.vue")
  },
  {
    name: "politica-de-cookies",
    path: "/politica-de-cookies",
    component: () => import("/app/app/pages/politica-de-cookies.vue")
  },
  {
    name: "politica-de-privacidade",
    path: "/politica-de-privacidade",
    component: () => import("/app/app/pages/politica-de-privacidade.vue")
  },
  {
    name: "sobre-a-pilar",
    path: "/sobre-a-pilar",
    meta: sobre_45a_45pilarIJNr3UkQoYMeta || {},
    component: () => import("/app/app/pages/sobre-a-pilar.vue")
  },
  {
    name: "termos-de-uso",
    path: "/termos-de-uso",
    component: () => import("/app/app/pages/termos-de-uso.vue")
  },
  {
    name: "termos-politica-de-privacidade",
    path: "/termos/politica-de-privacidade",
    meta: politica_45de_45privacidadepQi9ucIS88Meta || {},
    component: () => import("/app/app/pages/termos/politica-de-privacidade.vue")
  },
  {
    name: "termos-termo-de-responsabilidade-dados-pessoais",
    path: "/termos/termo-de-responsabilidade-dados-pessoais",
    meta: termo_45de_45responsabilidade_45dados_45pessoais1JAH84Ff3QMeta || {},
    component: () => import("/app/app/pages/termos/termo-de-responsabilidade-dados-pessoais.vue")
  },
  {
    name: "termos-termo-de-uso-b2c",
    path: "/termos/termo-de-uso-b2c",
    meta: termo_45de_45uso_45b2c4Ww2GXfkMiMeta || {},
    component: () => import("/app/app/pages/termos/termo-de-uso-b2c.vue")
  },
  {
    name: "PropertiesListing",
    path: "/venda/imoveis/:filterSlugs(.*)*",
    meta: _91_46_46_46filterSlugs_93xl0zcCbgIlMeta || {},
    alias: ["/venda/imoveis","/aluguel/imoveis"],
    component: () => import("/app/app/pages/venda/imoveis/[...filterSlugs].vue")
  },
  {
    name: "PropertiesMapListing",
    path: "/venda/mapa-de-imoveis/:filterSlugs(.*)*",
    meta: _91_46_46_46filterSlugs_93vX2UX9obqKMeta || {},
    alias: ["/venda/mapa-de-imoveis","/aluguel/mapa-de-imoveis"],
    component: () => import("/app/app/pages/venda/mapa-de-imoveis/[...filterSlugs].vue")
  }
]